
const e=[{cookie:`fdBetaApplicationsQueue`,featureFlag:`betaApplicationsQueue`,paths:[{daffy:`/v3/dashboard/journeys/applications`,frontendDashboard:`/beta/journeys/applications`}]}];export{e as routeRolloutRegistry};